import React from 'react';
import steps from '../steps'; // Assuming steps definition is in src/steps.js
import '../styles/StepsIndicator.scss';

function StepsIndicator({ currentStep, setStep, category, question }) {

  const handleStepClick = (stepId) => {
    // Validation rules (similar to Sidebar)
    if (stepId > currentStep) {
      // Allow navigation forward only one step at a time if needed,
      // or prevent jumping ahead entirely. For now, just prevent jumping far ahead.
      if (stepId > currentStep + 1) {
         alert("Please complete the previous steps first.");
         return;
      }
       // Allow moving forward one step if needed by logic, otherwise prevent
       // For simplicity, we might just prevent *any* forward clicking here
       // alert("Please complete the current step first.");
       // return;
    }

    // Prevent going back before required data exists
    if ((stepId === 2 || stepId === 3) && !category && currentStep >= 1) {
      alert("Please select a category before proceeding or going back.");
      setStep(1); // Force back to step 1 if category is missing
      return;
    }

    if ((stepId === 3 || stepId === 4) && !question && currentStep >= 2) {
        // Special case for grammar checkers that skip step 2
        const isGrammarChecker = category === 'Grammar Checker' || category === 'FR_Grammar' || category === 'ES_Grammar' || category === 'DE_Grammar';
        if (!isGrammarChecker) {
           alert("Please select or enter a question before proceeding or going back.");
           setStep(2); // Force back to step 2 if question is missing (and not grammar checker)
           return;
        }
    }

    // Allow navigation if validation passes
    setStep(stepId);
  };

  // Determine the highest completed step to enable clicking
  // Or just use currentStep to limit navigation
  const highestClickableStep = currentStep; // Or currentStep + 1 if allow moving forward one step

  return (
    <div className="steps-indicator-container">
      <ul className="steps-indicator-list">
        {steps.map((step) => (
          <li
            key={step.id}
            className={`
              steps-indicator-item
              ${currentStep === step.id ? 'active' : ''}
              ${currentStep > step.id ? 'completed' : ''}
              ${step.id > highestClickableStep ? 'disabled' : ''}
            `}
            onClick={() => step.id <= highestClickableStep ? handleStepClick(step.id) : null}
          >
            <div className="step-number-indicator">
              {currentStep > step.id ? '✓' : step.id}
            </div>
            <div className="step-label-indicator">{step.label}</div>
            {/* Add connecting lines */}
            {step.id < steps.length && <div className="step-connector"></div>}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default StepsIndicator;
